export default "__VITE_ASSET__a6a50d52__"